import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { useNavigate } from "react-router-dom";
import { IEventInfo } from "./EventCalendar";

interface IProps {
  open: boolean;
  handleClose: Dispatch<SetStateAction<void>>;
  currentEvent: IEventInfo | null;
}

const EventInfoModal = ({ open, handleClose, currentEvent }: IProps) => {
  const navigate = useNavigate();
  const onClose = () => {
    handleClose();
  };

  console.log({ currentEvent });

  return (
    <Dialog open={open} onClose={onClose}>
      <Stack
        direction="column"
        sx={{
          width: 300,
        }}
      >
        <DialogTitle>Day resume</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Stack>
              <Typography
                sx={{ fontSize: 18, color: "GrayText" }}
                fontWeight="semibold"
              >
                {`Total receipt: ${currentEvent?.total_receipt}`}
              </Typography>
              <Typography
                sx={{ fontSize: 18, color: "GrayText" }}
                fontWeight="semibold"
              >
                {`Total paid: ${currentEvent?.paid}`}
              </Typography>
              <Typography
                sx={{ fontSize: 18, color: "GrayText" }}
                fontWeight="semibold"
              >{`Total unpaid: ${currentEvent?.unpaid}`}</Typography>
              <Typography
                sx={{ fontSize: 18, color: "GrayText" }}
                fontWeight="semibold"
              >
                {`Total amount given: ${currentEvent?.total_amount_given}`}
              </Typography>
              <Typography
                sx={{ fontSize: 18, color: "GrayText" }}
                fontWeight="semibold"
              >
                {`Total amount received: ${currentEvent?.total_amount_received}`}
              </Typography>
              <Typography
                sx={{ fontSize: 18, color: "GrayText" }}
                fontWeight="semibold"
              >
                {`Missing: ${
                  Number(currentEvent?.total_amount_received) -
                  Number(currentEvent?.total_amount_given)
                }`}
              </Typography>
            </Stack>
          </DialogContentText>
          <Box component="form"></Box>
        </DialogContent>
        <DialogActions>
          <Button color="error" onClick={onClose}>
            Close
          </Button>
          <Button
            color="success"
            onClick={() => navigate(`/receipts/edit/${currentEvent?.id}`)}
          >
            Edit
          </Button>
          <Button
            color="info"
            onClick={() => navigate(`/receipts/show/${currentEvent?.id}`)}
          >
            Show
          </Button>
        </DialogActions>
      </Stack>
    </Dialog>
  );
};

export default EventInfoModal;
